export default __webpack_public_path__ + "static/media/trophy-circle.b540282d.svg";